export const organizationConstants = {
  ORGANIZATION_LOAD: '[Organization] Load',
  ORGANIZATION_LOAD_SUCCESS: '[Organization] Load success',
  ORGANIZATION_LOAD_FAILURE: '[Organization] Load failure',
  ORGANIZATION_RESET: '[Organization] Reset',
  ORGANIZATION_SAVE: '[Organization] Save',
  ORGANIZATION_SAVE_SUCCESS: '[Organization] Save success',
  ORGANIZATION_SAVE_FAILURE: '[Organization] Save failure',
  ORGANIZATION_JOIN: '[Organization] Join',
  ORGANIZATION_JOIN_SUCCESS: '[Organization] Join success',
  ORGANIZATION_JOIN_FAILURE: '[Organization] Join failure'
}
